
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyW1W14hWk_45Pum5fRKT7JjvZbabtYz8I_HkpGiq8eujYMeta } from "/app/apps/web/pages/api/index.vue?macro=true";
import { default as _91slug_93TDbSz3_454SWuulGhtYUNFfE4X2nPrmgL4aLaOERFmAssMeta } from "/app/apps/web/pages/api/[slug].vue?macro=true";
import { default as apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta } from "/app/apps/web/pages/api.vue?macro=true";
import { default as indexvHXs7DvS6b2hElWqs0nnwE3gZ6wT5fRkp0QC_459QmDB8Meta } from "/app/apps/web/pages/index.vue?macro=true";
import { default as pricingnn4Z7qM1ZK_P2as2L1xKMS9xOxKOUSu9CwffOov8mIkMeta } from "/app/apps/web/pages/pricing.vue?macro=true";
import { default as teamjs38JKvJ0dnLBtt1EaeNQ9v5kORfUxCm_OxAlENrcMYMeta } from "/app/apps/web/pages/settings/team.vue?macro=true";
import { default as indexNQdLZyBJEFaVYuE8ReeqU3PI_PhI81hNI4EasSWaNJAMeta } from "/app/apps/web/pages/settings/index.vue?macro=true";
import { default as usageRMu_xpLymiCNKQq5lOnCMauJrF5H8JYZrUpOnHvwN6YMeta } from "/app/apps/web/pages/settings/usage.vue?macro=true";
import { default as profile_Kguz3E8XlRKlZxmN6bmfdRSzQfU_45ksr7whS1f7BgxgMeta } from "/app/apps/web/pages/settings/profile.vue?macro=true";
import { default as webhooksy_8wivoswQBf7t2nx6PPuCXTm1eEH_45Bc1hsNO_ymbA4Meta } from "/app/apps/web/pages/settings/webhooks.vue?macro=true";
import { default as documentssh6k1CAcFRYowdjpW7OICeaU9XeRFomSBlT_zRvAy78Meta } from "/app/apps/web/pages/settings/documents.vue?macro=true";
import { default as api_45tokensoQgVOGLe_slNpvBSk04ySf5ME4Sbr599eMjTx_45vz8zoMeta } from "/app/apps/web/pages/settings/api-tokens.vue?macro=true";
import { default as subscriptionF6geR_I6mLMBjdCCyX_45s_8L_nGkUbUucFXTRG6oxjpIMeta } from "/app/apps/web/pages/settings/subscription.vue?macro=true";
import { default as settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta } from "/app/apps/web/pages/settings.vue?macro=true";
import { default as indexoBtiK9JNQl4oXYxtj1GkIn2vZgBZ2ELvbeBSD8WVS9sMeta } from "/app/apps/web/pages/companies/index.vue?macro=true";
import { default as enrichmentVWIulo1TZNqB8QLQs2MZT00j2a2FwaxC9luwdvSJqMAMeta } from "/app/apps/web/pages/companies/enrichment.vue?macro=true";
import { default as similaritySpoLWfsTvq1Lx6zjwaPkX4PbKR_45eIud_45MUZDZNIdZSsMeta } from "/app/apps/web/pages/companies/similarity.vue?macro=true";
import { default as index0u1T_45y6qAXoPSsgcZenfY5Y5j_PkgyOp0Kwmlq1C3UIMeta } from "/app/apps/web/pages/companies/lists/[listId]/index.vue?macro=true";
import { default as analytics5J4gsPmi4_s4a9eXVDRNOe0ZoudEMvNne1tV5s_45_30AMeta } from "/app/apps/web/pages/companies/lists/[listId]/analytics.vue?macro=true";
import { default as companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta } from "/app/apps/web/pages/companies.vue?macro=true";
import { default as _91slug_931cFQo_45oT3Ct0urnETVr8Ss4LSPew0RWcIKpzyuX356IMeta } from "/app/apps/web/pages/use-cases/[slug].vue?macro=true";
import { default as use_45casesQODrnzrJbi8aoNu73AuQ6PjH1MI_xb6SLthKHd_45uZUMMeta } from "/app/apps/web/pages/use-cases.vue?macro=true";
import { default as loginZhkeMT_457vtRjX4zQDc7HXYp4iYpzGzd51_hlbelgRT4Meta } from "/app/apps/web/pages/auth/login.vue?macro=true";
import { default as reset3QM1K1s_45JseelAu3rj8XRh_45PjfGNeaKTxMr1V0TaA0IMeta } from "/app/apps/web/pages/auth/reset.vue?macro=true";
import { default as logout0_4wuXmbKv59TTpHUhRfLuCNoRDI16sgxFsHjw9nbK8Meta } from "/app/apps/web/pages/auth/logout.vue?macro=true";
import { default as faqgAqlr7d0E1KLX1Kh_45QybIQKcsYY2x_45_oPGD_45cRcYXKEMeta } from "/app/apps/web/pages/product/faq.vue?macro=true";
import { default as termsjS1KJEy7TEClh9evnMruIwsDjQf8UmzbLBPiCKazUTYMeta } from "/app/apps/web/pages/product/terms.vue?macro=true";
import { default as extensionxBd7QqRzNF76o2IIXEl_LNq3YN2emGFDIJ4DICIbsLYMeta } from "/app/apps/web/pages/auth/extension.vue?macro=true";
import { default as privacy7S5KzVJMsDCTEhine8cgc1COfvWqfxA3muCq38wYe0QMeta } from "/app/apps/web/pages/product/privacy.vue?macro=true";
import { default as verification7fQk7SfztIej_45OdrqKGzZNk_eeecgEGqQp_45J8opRNPUMeta } from "/app/apps/web/pages/auth/verification.vue?macro=true";
import { default as component_45stubWM7PsP9QoIPc8eJKKBrJe94IvTRX7rZs4SIK0126ReoMeta } from "/app/node_modules/.pnpm/nuxt@3.17.1_@types+node@22.15.21_eslint@9.15.0_ioredis@5.4.1_rollup@4.40.1_typescript@5.6.3_v_aimeh3knaoyzr6hujmlqqqe43e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubWM7PsP9QoIPc8eJKKBrJe94IvTRX7rZs4SIK0126Reo } from "/app/node_modules/.pnpm/nuxt@3.17.1_@types+node@22.15.21_eslint@9.15.0_ioredis@5.4.1_rollup@4.40.1_typescript@5.6.3_v_aimeh3knaoyzr6hujmlqqqe43e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta?.name,
    path: "/api",
    meta: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta || {},
    component: () => import("/app/apps/web/pages/api.vue"),
    children: [
  {
    name: "api___en",
    path: "",
    component: () => import("/app/apps/web/pages/api/index.vue")
  },
  {
    name: "api-slug___en",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/api/[slug].vue")
  }
]
  },
  {
    name: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta?.name,
    path: "/es/api",
    meta: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta || {},
    component: () => import("/app/apps/web/pages/api.vue"),
    children: [
  {
    name: "api___es",
    path: "",
    component: () => import("/app/apps/web/pages/api/index.vue")
  },
  {
    name: "api-slug___es",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/api/[slug].vue")
  }
]
  },
  {
    name: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta?.name,
    path: "/fr/api",
    meta: apiaGzPVqHv8JQpx9qQg6iTHz8W7qRLXi1VTUrCeHEMrYcMeta || {},
    component: () => import("/app/apps/web/pages/api.vue"),
    children: [
  {
    name: "api___fr",
    path: "",
    component: () => import("/app/apps/web/pages/api/index.vue")
  },
  {
    name: "api-slug___fr",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/api/[slug].vue")
  }
]
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/apps/web/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/apps/web/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/apps/web/pages/index.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    component: () => import("/app/apps/web/pages/pricing.vue")
  },
  {
    name: "pricing___es",
    path: "/es/pricing",
    component: () => import("/app/apps/web/pages/pricing.vue")
  },
  {
    name: "pricing___fr",
    path: "/fr/pricing",
    component: () => import("/app/apps/web/pages/pricing.vue")
  },
  {
    name: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta?.name,
    path: "/settings",
    meta: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta || {},
    component: () => import("/app/apps/web/pages/settings.vue"),
    children: [
  {
    name: "settings-team___en",
    path: "team",
    component: () => import("/app/apps/web/pages/settings/team.vue")
  },
  {
    name: "settings___en",
    path: "",
    component: () => import("/app/apps/web/pages/settings/index.vue")
  },
  {
    name: "settings-usage___en",
    path: "usage",
    component: () => import("/app/apps/web/pages/settings/usage.vue")
  },
  {
    name: "settings-profile___en",
    path: "profile",
    component: () => import("/app/apps/web/pages/settings/profile.vue")
  },
  {
    name: "settings-webhooks___en",
    path: "webhooks",
    component: () => import("/app/apps/web/pages/settings/webhooks.vue")
  },
  {
    name: "settings-documents___en",
    path: "documents",
    component: () => import("/app/apps/web/pages/settings/documents.vue")
  },
  {
    name: "settings-api-tokens___en",
    path: "api-tokens",
    component: () => import("/app/apps/web/pages/settings/api-tokens.vue")
  },
  {
    name: "settings-subscription___en",
    path: "subscription",
    component: () => import("/app/apps/web/pages/settings/subscription.vue")
  }
]
  },
  {
    name: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta?.name,
    path: "/es/settings",
    meta: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta || {},
    component: () => import("/app/apps/web/pages/settings.vue"),
    children: [
  {
    name: "settings-team___es",
    path: "team",
    component: () => import("/app/apps/web/pages/settings/team.vue")
  },
  {
    name: "settings___es",
    path: "",
    component: () => import("/app/apps/web/pages/settings/index.vue")
  },
  {
    name: "settings-usage___es",
    path: "usage",
    component: () => import("/app/apps/web/pages/settings/usage.vue")
  },
  {
    name: "settings-profile___es",
    path: "profile",
    component: () => import("/app/apps/web/pages/settings/profile.vue")
  },
  {
    name: "settings-webhooks___es",
    path: "webhooks",
    component: () => import("/app/apps/web/pages/settings/webhooks.vue")
  },
  {
    name: "settings-documents___es",
    path: "documents",
    component: () => import("/app/apps/web/pages/settings/documents.vue")
  },
  {
    name: "settings-api-tokens___es",
    path: "api-tokens",
    component: () => import("/app/apps/web/pages/settings/api-tokens.vue")
  },
  {
    name: "settings-subscription___es",
    path: "subscription",
    component: () => import("/app/apps/web/pages/settings/subscription.vue")
  }
]
  },
  {
    name: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta?.name,
    path: "/fr/settings",
    meta: settings9TH5xFafCHgnEvYkWgcdCOM6A8JO7HlOyplL2pxz7a4Meta || {},
    component: () => import("/app/apps/web/pages/settings.vue"),
    children: [
  {
    name: "settings-team___fr",
    path: "team",
    component: () => import("/app/apps/web/pages/settings/team.vue")
  },
  {
    name: "settings___fr",
    path: "",
    component: () => import("/app/apps/web/pages/settings/index.vue")
  },
  {
    name: "settings-usage___fr",
    path: "usage",
    component: () => import("/app/apps/web/pages/settings/usage.vue")
  },
  {
    name: "settings-profile___fr",
    path: "profile",
    component: () => import("/app/apps/web/pages/settings/profile.vue")
  },
  {
    name: "settings-webhooks___fr",
    path: "webhooks",
    component: () => import("/app/apps/web/pages/settings/webhooks.vue")
  },
  {
    name: "settings-documents___fr",
    path: "documents",
    component: () => import("/app/apps/web/pages/settings/documents.vue")
  },
  {
    name: "settings-api-tokens___fr",
    path: "api-tokens",
    component: () => import("/app/apps/web/pages/settings/api-tokens.vue")
  },
  {
    name: "settings-subscription___fr",
    path: "subscription",
    component: () => import("/app/apps/web/pages/settings/subscription.vue")
  }
]
  },
  {
    name: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta?.name,
    path: "/companies",
    meta: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta || {},
    component: () => import("/app/apps/web/pages/companies.vue"),
    children: [
  {
    name: "companies___en",
    path: "",
    component: () => import("/app/apps/web/pages/companies/index.vue")
  },
  {
    name: "companies-enrichment___en",
    path: "enrichment",
    component: () => import("/app/apps/web/pages/companies/enrichment.vue")
  },
  {
    name: "companies-similarity___en",
    path: "similarity",
    component: () => import("/app/apps/web/pages/companies/similarity.vue")
  },
  {
    name: "companies-lists-listId___en",
    path: "lists/:listId()",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/index.vue")
  },
  {
    name: "companies-lists-listId-analytics___en",
    path: "lists/:listId()/analytics",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/analytics.vue")
  }
]
  },
  {
    name: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta?.name,
    path: "/es/companies",
    meta: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta || {},
    component: () => import("/app/apps/web/pages/companies.vue"),
    children: [
  {
    name: "companies___es",
    path: "",
    component: () => import("/app/apps/web/pages/companies/index.vue")
  },
  {
    name: "companies-enrichment___es",
    path: "enrichment",
    component: () => import("/app/apps/web/pages/companies/enrichment.vue")
  },
  {
    name: "companies-similarity___es",
    path: "similarity",
    component: () => import("/app/apps/web/pages/companies/similarity.vue")
  },
  {
    name: "companies-lists-listId___es",
    path: "lists/:listId()",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/index.vue")
  },
  {
    name: "companies-lists-listId-analytics___es",
    path: "lists/:listId()/analytics",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/analytics.vue")
  }
]
  },
  {
    name: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta?.name,
    path: "/fr/companies",
    meta: companiesfX4C0DLORjI8j0pr9ArHWWluBtE1CECbt8lwg7yY_45eoMeta || {},
    component: () => import("/app/apps/web/pages/companies.vue"),
    children: [
  {
    name: "companies___fr",
    path: "",
    component: () => import("/app/apps/web/pages/companies/index.vue")
  },
  {
    name: "companies-enrichment___fr",
    path: "enrichment",
    component: () => import("/app/apps/web/pages/companies/enrichment.vue")
  },
  {
    name: "companies-similarity___fr",
    path: "similarity",
    component: () => import("/app/apps/web/pages/companies/similarity.vue")
  },
  {
    name: "companies-lists-listId___fr",
    path: "lists/:listId()",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/index.vue")
  },
  {
    name: "companies-lists-listId-analytics___fr",
    path: "lists/:listId()/analytics",
    component: () => import("/app/apps/web/pages/companies/lists/[listId]/analytics.vue")
  }
]
  },
  {
    name: "use-cases___en",
    path: "/use-cases",
    component: () => import("/app/apps/web/pages/use-cases.vue"),
    children: [
  {
    name: "use-cases-slug___en",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/use-cases/[slug].vue")
  }
]
  },
  {
    name: "use-cases___es",
    path: "/es/use-cases",
    component: () => import("/app/apps/web/pages/use-cases.vue"),
    children: [
  {
    name: "use-cases-slug___es",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/use-cases/[slug].vue")
  }
]
  },
  {
    name: "use-cases___fr",
    path: "/fr/use-cases",
    component: () => import("/app/apps/web/pages/use-cases.vue"),
    children: [
  {
    name: "use-cases-slug___fr",
    path: ":slug()",
    component: () => import("/app/apps/web/pages/use-cases/[slug].vue")
  }
]
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    component: () => import("/app/apps/web/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/es/auth/login",
    component: () => import("/app/apps/web/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr",
    path: "/fr/auth/login",
    component: () => import("/app/apps/web/pages/auth/login.vue")
  },
  {
    name: "auth-reset___en",
    path: "/auth/reset",
    component: () => import("/app/apps/web/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___es",
    path: "/es/auth/reset",
    component: () => import("/app/apps/web/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___fr",
    path: "/fr/auth/reset",
    component: () => import("/app/apps/web/pages/auth/reset.vue")
  },
  {
    name: "auth-logout___en",
    path: "/auth/logout",
    component: () => import("/app/apps/web/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___es",
    path: "/es/auth/logout",
    component: () => import("/app/apps/web/pages/auth/logout.vue")
  },
  {
    name: "auth-logout___fr",
    path: "/fr/auth/logout",
    component: () => import("/app/apps/web/pages/auth/logout.vue")
  },
  {
    name: "product-faq___en",
    path: "/product/faq",
    component: () => import("/app/apps/web/pages/product/faq.vue")
  },
  {
    name: "product-faq___es",
    path: "/es/product/faq",
    component: () => import("/app/apps/web/pages/product/faq.vue")
  },
  {
    name: "product-faq___fr",
    path: "/fr/product/faq",
    component: () => import("/app/apps/web/pages/product/faq.vue")
  },
  {
    name: "product-terms___en",
    path: "/product/terms",
    component: () => import("/app/apps/web/pages/product/terms.vue")
  },
  {
    name: "product-terms___es",
    path: "/es/product/terms",
    component: () => import("/app/apps/web/pages/product/terms.vue")
  },
  {
    name: "product-terms___fr",
    path: "/fr/product/terms",
    component: () => import("/app/apps/web/pages/product/terms.vue")
  },
  {
    name: "auth-extension___en",
    path: "/auth/extension",
    component: () => import("/app/apps/web/pages/auth/extension.vue")
  },
  {
    name: "auth-extension___es",
    path: "/es/auth/extension",
    component: () => import("/app/apps/web/pages/auth/extension.vue")
  },
  {
    name: "auth-extension___fr",
    path: "/fr/auth/extension",
    component: () => import("/app/apps/web/pages/auth/extension.vue")
  },
  {
    name: "product-privacy___en",
    path: "/product/privacy",
    component: () => import("/app/apps/web/pages/product/privacy.vue")
  },
  {
    name: "product-privacy___es",
    path: "/es/product/privacy",
    component: () => import("/app/apps/web/pages/product/privacy.vue")
  },
  {
    name: "product-privacy___fr",
    path: "/fr/product/privacy",
    component: () => import("/app/apps/web/pages/product/privacy.vue")
  },
  {
    name: "auth-verification___en",
    path: "/auth/verification",
    component: () => import("/app/apps/web/pages/auth/verification.vue")
  },
  {
    name: "auth-verification___es",
    path: "/es/auth/verification",
    component: () => import("/app/apps/web/pages/auth/verification.vue")
  },
  {
    name: "auth-verification___fr",
    path: "/fr/auth/verification",
    component: () => import("/app/apps/web/pages/auth/verification.vue")
  },
  {
    name: component_45stubWM7PsP9QoIPc8eJKKBrJe94IvTRX7rZs4SIK0126ReoMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubWM7PsP9QoIPc8eJKKBrJe94IvTRX7rZs4SIK0126Reo
  }
]